import { useCallback, useEffect, useState } from "react";
import { useCreatePartnerCodeGroupMutation } from "../../Hooks/useCreatePartnerGroupMutation";
import PartnerCodeGroupFormModal from "../PartnerCodeGroupForm/PartnerCodeGroupForm";

function CreatePartnerCodeGroupModel({
  createPartnerCodeGroupModalOpen,
  closeCreatePartnerCodeGroupModal,
  setToast,
  refetch,
  codeGroupType,
}) {
  const [partnerCodeGroupData, setPartnerCodeGroupData] = useState({
    codeGroupType,
  });

  // Sync codeGroupType when prop changes
  useEffect(() => {
    if (codeGroupType) {
      setPartnerCodeGroupData((prev) => ({ ...prev, codeGroupType }));
    }
  }, [codeGroupType]);
  const [createPartnerCodeGroupMutation, { loading }] =
    useCreatePartnerCodeGroupMutation();

  const handleCreatePartnerCodeGroup = useCallback(
    async (data) => {
      const dataToUse = data || partnerCodeGroupData;
      // Exclude rewardItemFileData from initial mutation - will upload after group creation
      // eslint-disable-next-line no-unused-vars
      const { rewardItemFileData, ...dataWithoutFiles } = dataToUse;
      const dataToSubmit = {
        ...dataWithoutFiles,
        rewardItemFileData: [],
      };
      return new Promise((resolve) => {
        const onSuccess = (entity) => {
          resolve(entity);
        };

        const onFailure = (error) => {
          setToast({
            open: true,
            type: "error",
            title: `Error creating Code Group: ${dataToUse?.name}`,
            description: error?.message || "",
          });
          resolve(null);
        };

        createPartnerCodeGroupMutation(onSuccess, onFailure, dataToSubmit);
      });
    },
    [createPartnerCodeGroupMutation, partnerCodeGroupData, setToast]
  );

  const handleComplete = useCallback(() => {
    setToast({
      open: true,
      type: "success",
      title: `Code Group ${partnerCodeGroupData?.name} Created!`,
      description: "You have just published a partner Group!",
    });
    setPartnerCodeGroupData({});
    closeCreatePartnerCodeGroupModal();
    refetch();
  }, [closeCreatePartnerCodeGroupModal, partnerCodeGroupData, refetch, setToast]);

  return (
    <PartnerCodeGroupFormModal
      isOpen={createPartnerCodeGroupModalOpen}
      toggleCreatePartnerCodeModal={closeCreatePartnerCodeGroupModal}
      closeModal={closeCreatePartnerCodeGroupModal}
      partnerCodeGroupData={partnerCodeGroupData}
      setPartnerCodeGroupData={setPartnerCodeGroupData}
      handleMutation={handleCreatePartnerCodeGroup}
      handleComplete={handleComplete}
      loading={loading}
      title="Create"
      isEditMode={false}
      codeGroupType={codeGroupType}
    />
  );
}

export default CreatePartnerCodeGroupModel;
